import { backendUrl } from "../services/backendUrl";

// Non-project static content for Sanggavai Constructions.
// Project listings themselves are fetched live from Api/projects.php.

export const galleryImages = [
  backendUrl("/static/images/10024.jpg"),
  backendUrl("/static/images/10025.jpg"),
  backendUrl("/static/images/10026.jpg"),
  backendUrl("/static/images/10027.jpg"),
  backendUrl("/static/images/10038.jpg"),
  backendUrl("/static/images/10039.jpg"),
  backendUrl("/static/images/10040.jpg"),
  backendUrl("/static/images/10042.jpeg"),
  backendUrl("/static/images/10036.jpg"),
];

export const services = [
  { title: "Joint Venture", tagline: "Unlock the value of your land with a trusted builder." },
  { title: "Design & Build", tagline: "End-to-end residential and commercial construction." },
  { title: "Commercial Spaces", tagline: "Offices and retail spaces crafted for longevity." },
];

export const careers = [
  { role: "Site Engineer", type: "Full Time", location: "Chennai" },
  { role: "Civil Supervisor", type: "Full Time", location: "Chennai" },
  { role: "Project Manager", type: "Full Time", location: "Chennai" },
  { role: "Sales Executive", type: "Full Time", location: "Chennai" },
  { role: "Architect", type: "Full Time", location: "Chennai" },
];

export const HERO_IMAGE = backendUrl("/static/images/10002.jpg");
export const FEATURE_IMAGE = backendUrl("/Pearlhouse-cover.webp");
export const LOGO_URL = backendUrl("/uploads/sanggavai-logo.png");
